<template>
  <div class="read-only channels-read-only">
    <div class="d-flex flex-column read-only__item">
      <label class="text-black">
        Name
      </label>
      <span>{{ channel.name }}</span>
    </div>

    <div class="d-flex flex-column read-only__item">
      <label class="text-black">
        Short Name
      </label>
      <span>{{ channel.short_name }}</span>
    </div>

    <div class="d-flex flex-column read-only__item">
      <label class="text-black">
        Website
      </label>
      <a
        :href="channel.url"
        target="_blank"
      >
        {{ channel.url }}
      </a>
    </div>

    <div class="d-flex flex-column read-only__item">
      <label class="text-black">
        Email
      </label>
      <a :href="`mailto: ${channel.email}`">
        {{ channel.email }}
      </a>
    </div>

    <div class="d-flex flex-column read-only__item">
      <label class="text-black">
        Address
      </label>
      <span>{{ channel.default_address.address1 }}</span>
    </div>

    <div class="d-flex flex-column read-only__item">
      <label class="text-black">
        City
      </label>
      <span>{{ channel.default_address.city }}</span>
    </div>

    <div class="d-flex flex-column read-only__item">
      <label class="text-black">
        Postcode
      </label>
      <span>{{ channel.default_address.postal_code }}</span>
    </div>

    <div
      class="d-flex flex-column read-only__item"
      v-if="channel.countries.length"
    >
      <label class="text-black">
        Country
      </label>
      <span>{{ channel.default_address.country.name }}</span>
    </div>

    <div class="d-flex flex-column read-only__item">
      <label class="text-black">
        Logo
      </label>
      <img
        :src="channel.logo_url"
        :alt="channel.name"
        width="200"
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    channel: {
      type: Object,
      required: true,
    },
  },
}
</script>

